import {
  HOME_FETCH_START,
  HOME_FETCH_SUCCESS,
  HOME_FETCH_FAILURE,
  ACCOUNT_FETCH_FAILURE,
  ACCOUNT_FETCH_START,
  ACCOUNT_FETCH_SUCCESS,
  MEMBER_TYPE_FETCH_START,
  MEMBER_TYPE_FETCH_SUCCESS,
  MEMBER_TYPE_FETCH_FAILURE,
  TOTAL_POTINFO_FETCH_START,
  TOTAL_POTINFO_FETCH_FAILURE,
  TOTAL_POTINFO_FETCH_SUCCESS,
  MANAGE_FETCH_START,
  MANAGE_FETCH_SUCCESS,
  MANAGE_FETCH_FAILURE,
  INVESTOR_ID_FETCH_START,
  INVESTOR_ID_FETCH_SUCCESS,
  INVESTOR_ID_FETCH_FAILURE,
  ACCOUNT_PATCH_START,
  ACCOUNT_PATCH_SUCCESS,
  ACCOUNT_PATCH_FAILURE,
  FUND_HISTORY_FETCH_SUCCESS,
  FUND_HISTORY_FETCH_START,
  FUND_HISTORY_FETCH_FAILURE,
  ADDRESS_FETCH_START,
  ADDRESS_FETCH_SUCCESS,
  ADDRESS_FETCH_FAILURE,
  UPLOAD_DOC_PATCH_START,
  UPLOAD_DOC_PATCH_FAILURE,
  UPLOAD_DOC_PATCH_SUCCESS,
  SUBMIT_DOC_PATCH_START,
  SUBMIT_DOC_PATCH_SUCCESS,
  SUBMIT_DOC_PATCH_FAILURE,
  MEMBER_LIST_FETCH_START,
  MEMBER_LIST_FETCH_SUCCESS,
  MEMBER_LIST_FETCH_FAILURE,
  MEMBER_DETAILS_FETCH_SUCCESS,
  MEMBER_DETAILS_FETCH_FAILURE,
  MEMBER_DETAILS_FETCH_START,
  RETIREMENT_APPLICATION_FETCH_START,
  RETIREMENT_APPLICATION_FETCH_SUCCESS,
  RETIREMENT_APPLICATION_FETCH_FAILURE,
  BENEFICIARY_FETCH_START,
  BENEFICIARY_FETCH_SUCCESS,
  BENEFICIARY_FETCH_FAILURE,
  FUNDS_SAVINGS_FETCH_FAILURE,
  CHAT_TOKEN_START,
  CHAT_TOKEN_SUCCESS,
  CHAT_TOKEN_FAILURE,
  SCHEME_PROTECTION_FETCH_START,
  SCHEME_PROTECTION_FETCH_SUCCESS,
  SCHEME_PROTECTION_FETCH_FAILURE,
  FUNDS_SAVINGS_FETCH_SUCCESS,
  FUNDS_SAVINGS_FETCH_START,
  BENEFICIARY_POST_FETCH_START,
  BENEFICIARY_POST_FETCH_SUCCESS,
  BENEFICIARY_POST_FETCH_FAILURE,
  BENEFICIARY_PATCH_FETCH_START,
  BENEFICIARY_PATCH_FETCH_SUCCESS,
  BENEFICIARY_PATCH_FETCH_FAILURE,
  TRANSACTIONS_SUMMARY_FETCH_START,
  TRANSACTIONS_SUMMARY_FETCH_SUCCESS,
  TRANSACTIONS_SUMMARY_FETCH_FAILURE,
  FETCH_REFRESH_TOKEN_START,
  FETCH_REFRESH_TOKEN_SUCCESS,
  FETCH_REFRESH_TOKEN_FAILURE,
  TRANSERIN_FETCH_START,
  TRANSERIN_FETCH_SUCCESS,
  TRANSERIN_FETCH_FAILURE,
  RETIREMENT_APPLICATION_PATCH_START,
  RETIREMENT_APPLICATION_PATCH_SUCCESS,
  RETIREMENT_APPLICATION_PATCH_FAILURE,
  SET_RETIREMENT_APPLICATION_DETAILS,
  BEGIN_RETIREMENT_APPLICATION_CLICK_START,
  BACK_BUTTON_RETIREMENT_APPLICATION_STEPS,
  NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS,
  RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS,
  GUIDANCE_EXPLORER_FETCH_START,
  GUIDANCE_EXPLORER_SUCCESS,
  GUIDANCE_EXPLORER_FAILURE,
  GUIDANCE_EXPLORER_CARD_FETCH_START,
  GUIDANCE_EXPLORER_CARD_SUCCESS,
  GUIDANCE_EXPLORER_CARD_FAILURE,
  CMS_FUND_LIST_FETCH_START,
  CMS_FUND_LIST_FETCH_SUCCESS,
  CMS_FUND_LIST_FETCH_FAILURE,
  ALL_DOCUMENTS_FETCH_START,
  ALL_DOCUMENTS_FETCH_SUCCESS,
  ALL_DOCUMENTS_FETCH_FAILURE,
  GET_DOCUMENT_FETCH_START,
  GET_DOCUMENT_FETCH_SUCCESS,
  GET_DOCUMENT_FETCH_FAILURE,
  LIVING_STANDARD_FETCH_START,
  LIVING_STANDARD_FETCH_FAILURE,
  LIVING_STANDARD_FETCH_SUCCESS,
  PRODUCT_OVERVIEW_FETCH_START,
  PRODUCT_OVERVIEW_FETCH_SUCCESS,
  PRODUCT_OVERVIEW_FETCH_FAILURE,
  DOCUMENT_READ_STATUS_POST_FETCH_START,
  DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS,
  DOCUMENT_READ_STATUS_POST_FETCH_FAILURE,
  UPLOAD_DOC_GETINTOUCH_START,
  UPLOAD_DOC_GETINTOUCH_SUCCESS,
  UPLOAD_DOC_GETINTOUCH_FAILURE,
  LIVING_STANDARD_ASSUMPTIONS_FETCH_START,
  LIVING_STANDARD_ASSUMPTIONS_FETCH_SUCCESS,
  LIVING_STANDARD_ASSUMPTIONS_FETCH_FAILURE,
  COMM_PREFERENCE_FETCH_START,
  COMM_PREFERENCE_FETCH_SUCCESS,
  COMM_PREFERENCE_FETCH_FAILURE,
  YOUR_GOALS_FETCH_START,
  YOUR_GOALS_FETCH_SUCCESS,
  YOUR_GOALS_FETCH_FAILURE,
  POST_YOUR_GOALS_FETCH_START,
  POST_YOUR_GOALS_FETCH_SUCCESS,
  POST_YOUR_GOALS_FETCH_FAILURE,
  FOOTER_CONTENT_FETCH_START,
  FOOTER_CONTENT_FETCH_SUCCESS,
  FOOTER_CONTENT_FETCH_FAILURE,
  LEARN_LANDING_FETCH_START,
  LEARN_LANDING_FETCH_SUCCESS,
  LEARN_LANDING_FETCH_FAILURE,
  LEARN_LANDING_FILTER_FETCH_START,
  LEARN_LANDING_FILTER_FETCH_SUCCESS,
  LEARN_LANDING_FILTER_FETCH_FAILURE,
  LEARN_LANDING_FAQ_FETCH_START,
  LEARN_LANDING_FAQ_FETCH_SUCCESS,
  LEARN_LANDING_FAQ_FETCH_FAILURE,
  FC_HOME_FETCH_START,
  FC_HOME_FETCH_SUCCESS,
  FC_HOME_FETCH_FAILURE,
  POST_CONTRIBUTION_RATES_FETCH_START,
  POST_CONTRIBUTION_RATES_FETCH_SUCCESS,
  POST_CONTRIBUTION_RATES_FETCH_FAILURE,
  LEARN_LANDING_JARGON_BUSTER_FETCH_START,
  LEARN_LANDING_JARGON_BUSTER_FETCH_FAILURE,
  LEARN_LANDING_JARGON_BUSTER_FETCH_SUCCESS,
  I_WANT_TO_COMBO_FETCH_START,
  I_WANT_TO_COMBO_FETCH_FAILURE,
  I_WANT_TO_COMBO_FETCH_SUCCESS,
  INVESTMENT_DATA_FETCH_START,
  INVESTMENT_DATA_FETCH_FAILURE,
  INVESTMENT_DATA_FETCH_SUCCESS,
  CALCULATE_POT_FETCH_START,
  CALCULATE_POT_FETCH_SUCCESS,
  CALCULATE_POT_FETCH_FAILURE,
  RETIREMENT_QR_START,
  RETIREMENT_QR_SUCCESS,
  RETIREMENT_QR_FAILURE,
  RETIREMENT_IDENTITY_FETCH_START,
  RETIREMENT_IDENTITY_FETCH_SUCCESS,
  RETIREMENT_IDENTITY_FETCH_FAILURE,
  HOME_PROMO_FETCH_START,
  HOME_PROMO_FETCH_SUCCESS,
  HOME_PROMO_FETCH_FAILURE,
  NOTIFICATION_FETCH_START,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_FAILURE,
  TIME_TRAVEL_ASSUMPTIONS_FETCH_START,
  TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS,
  TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE,
  CONTRIBUTION_RATES_FETCH_START,
  CONTRIBUTION_RATES_FETCH_SUCCESS,
  CONTRIBUTION_RATES_FETCH_FAILURE,
  CALCULATOR_CMS_CONFIG_FETCH_START,
  CALCULATOR_CMS_CONFIG_FETCH_SUCCESS,
  CALCULATOR_CMS_CONFIG_FETCH_FAILURE,
  CONTRIBUTION_CALCULATOR_POST_FETCH_START,
  CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS,
  CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE,
  TRA_POST_FETCH_START,
  TRA_POST_FETCH_SUCCESS,
  TRA_POST_FETCH_FAILURE,
  RETIREMENT_CONFIRM_CHOICE_SUB_STEPS,
  RETIREMENT_DIRECT_STEP_CHANGE,
  HOME_ALERT_FETCH_START,
  HOME_ALERT_FETCH_SUCCESS,
  HOME_ALERT_FETCH_FAILURE,
  CONNECTED_PENSION_FETCH_START,
  CONNECTED_PENSION_FETCH_SUCCESS,
  CONNECTED_PENSION_FETCH_FAILURE,
  FC_FLEXI_RESULT_FETCH_START,
  FC_FLEXI_RESULT_FETCH_SUCCESS,
  FC_FLEXI_RESULT_FETCH_FAILURE,
  FC_INCOME_RESULT_FETCH_START,
  FC_INCOME_RESULT_FETCH_SUCCESS,
  FC_INCOME_RESULT_FETCH_FAILURE,
  FC_ANNUITY_RESULT_FETCH_START,
  FC_ANNUITY_RESULT_FETCH_SUCCESS,
  FC_ANNUITY_RESULT_FETCH_FAILURE,
  FC_WORTH_AMOUNT_FETCH_START,
  FC_WORTH_AMOUNT_FETCH_SUCCESS,
  FC_WORTH_AMOUNT_FETCH_FAILURE,
  ABOUT_TPT_FETCH_START,
  ABOUT_TPT_FETCH_SUCCESS,
  ABOUT_TPT_FETCH_FAILURE,
  FC_FLEXI_LINECHART_FETCH_START,
  FC_FLEXI_LINECHART_FETCH_SUCCESS,
  FC_FLEXI_LINECHART_FETCH_FAILURE,
  FC_FLEXI_INCOMECHART_FETCH_START,
  FC_FLEXI_INCOMECHART_FETCH_SUCCESS,
  FC_FLEXI_INCOMECHART_FETCH_FAILURE,
  FC_MANAGED_INCOMECHART_FETCH_START,
  FC_MANAGED_INCOMECHART_FETCH_SUCCESS,
  FC_MANAGED_INCOMECHART_FETCH_FAILURE,
  FC_ANNUITYCHART_FETCH_START,
  FC_ANNUITYCHART_FETCH_SUCCESS,
  FC_ANNUITYCHART_FETCH_FAILURE,
  FC_ASSUMPTIONS_FETCH_START,
  FC_ASSUMPTIONS_FETCH_SUCCESS,
  FC_ASSUMPTIONS_FETCH_FAILURE,
  LEARN_HELP_GUIDES_FETCH_START,
  LEARN_HELP_GUIDES_FETCH_SUCCESS,
  LEARN_HELP_GUIDES_FETCH_FAILURE,
  SCHEMA_DOCUMENT_FETCH_START,
  SCHEMA_DOCUMENT_FETCH_SUCCESS,
  SCHEMA_DOCUMENT_FETCH_FAILURE,
  FUND_SWITCH_FETCH_START,
  FUND_SWITCH_FETCH_SUCCESS,
  FUND_SWITCH_FETCH_FAILURE,
  DRAWDOWN_DATA_FETCH_START,
  DRAWDOWN_DATA_FETCH_SUCCESS,
  DRAWDOWN_DATA_FETCH_FAILURE,
  LEARN_SUPPORT_FETCH_START,
  LEARN_SUPPORT_FETCH_SUCCESS,
  LEARN_SUPPORT_FETCH_FAILURE,
  TRANSFER_OUT_FETCH_START,
  TRANSFER_OUT_FETCH_SUCCESS,
  TRANSFER_OUT_FETCH_FAILURE,
  LINKS_FETCH_FAILURE,
  LINKS_FETCH_SUCCESS,
  LINKS_FETCH_START,
  MESSAGES_FETCH_START,
  MESSAGES_FETCH_SUCCESS,
  MESSAGES_FETCH_FAILURE,
  MESSAGES_READ_FETCH_FAILURE,
  MESSAGES_READ_FETCH_SUCCESS,
  MESSAGES_READ_FETCH_START,
  LIFE_ASSURANCE_FETCH_START,
  LIFE_ASSURANCE_FETCH_SUCCESS,
  LIFE_ASSURANCE_FETCH_FAILURE,
  GRADES_FETCH_START,
  GRADES_FETCH_SUCCESS,
  GRADES_FETCH_FAILURE,
  CONTRIBUTION_VIEW_FETCH_FAILURE,
  CONTRIBUTION_VIEW_FETCH_SUCCESS,
  CONTRIBUTION_VIEW_FETCH_START,
  GET_TITLE_FETCH_START,
  GET_TITLE_FETCH_SUCCESS,
  GET_TITLE_FETCH_FAILURE,
  FEEDBACK_FETCH_START,
  FEEDBACK_FETCH_SUCCESS,
  FEEDBACK_FETCH_FAILURE,
  FUND_SWITCH_FUTURE_FETCH_START,
  FUND_SWITCH_FUTURE_FETCH_SUCCESS,
  FUND_SWITCH_FUTURE_FETCH_FAILURE,
  CALCULATE_POT_FETCH_MODAL_SUCCESS,
  HELP_GUIDES_FETCH_FAILURE,
  HELP_GUIDES_FETCH_SUCCESS,
  HELP_GUIDES_FETCH_START,
  FAQ_FETCH_START,
  FAQ_FETCH_SUCCESS,
  FAQ_FETCH_FAILURE,
  JARGON_FETCH_START,
  JARGON_FETCH_FAILURE,
  JARGON_FETCH_SUCCESS,
  COUNTRY_FETCH_START,
  COUNTRY_FETCH_SUCCESS,
  COUNTRY_FETCH_FAILURE,
  CHANGE_INVESTMENT_FETCH_START,
  CHANGE_INVESTMENT_FETCH_SUCCESS,
  CHANGE_INVESTMENT_FETCH_FAILURE,
  LUMP_SUMS_FETCH_START,
  LUMP_SUMS_FETCH_FAILURE,
  LUMP_SUMS_FETCH_SUCCESS,
  TAX_FREE_CREATE_FETCH_FAILURE,
  TAX_FREE_CREATE_FETCH_START,
  TAX_FREE_CREATE_FETCH_SUCCESS,
  TAX_FREE_STOP_FETCH_FAILURE,
  TAX_FREE_STOP_FETCH_START,
  TAX_FREE_STOP_FETCH_SUCCESS,
  FLEXI_ACCESS_INCOME_FETCH_START,
  FLEXI_ACCESS_INCOME_FETCH_SUCCESS,
  FLEXI_ACCESS_INCOME_FETCH_FAILURE,
  ILLUSTRATION_FETCH_FAILURE,
  ILLUSTRATION_FETCH_SUCCESS,
  ILLUSTRATION_FETCH_START,
  PAYOUT_RATE_FETCH_SUCCESS,
  PAYOUT_RATE_FETCH_START,
  PAYOUT_RATE_FETCH_FAILURE,
  RA_CMS_FUNDS_FETCH_FAILURE,
  RA_CMS_FUNDS_FETCH_SUCCESS,
  RA_CMS_FUNDS_FETCH_START,
  RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION,
  PENSION_LAB_CONSENT_FETCH_START,
  PENSION_LAB_CONSENT_FETCH_SUCCESS,
  PENSION_LAB_CONSENT_FETCH_FAILURE,
  PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS,
  PENSION_LAB_CONSENT_UPDATE_FETCH_START,
  PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE,
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS,
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE,
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START,
} from "./types";
import api from "../helpers/interceptor";
import { RA_STEPS_IDENTIFIERS, SETTINGS } from "../constants/index.js";
const env =
  process.env.REACT_APP_ENV === "local" ? "dev" : process.env.REACT_APP_ENV; //TODO - env variable to be changed, when building dev, qa, uat

function fetchRefreshToken() {
  const refreshToken =
    sessionStorage.getItem("refresh_token") ||
    localStorage.getItem("refresh_token");
  const urlencoded = new URLSearchParams();
  urlencoded.append("client_id", process.env.REACT_APP_TPT_SSO_CLIENT_ID);
  urlencoded.append("grant_type", "refresh_token");
  urlencoded.append("refresh_token", refreshToken);
  return new Promise((resolve) => {
    fetch(process.env.REACT_APP_TPT_SSO_TOKEN_URL, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: urlencoded,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          localStorage.clear();
          sessionStorage.clear();
          window.location.reload();
        }
        throw new Error("Error fetching data");
      })
      .then((data) => resolve(data))
      .catch((error) => {
        console.log("refresh toke error====>", error);
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      });
  });
}
export const fetchInvestorDetailsWithNewToken = () => {
  return (dispatch) => {
    dispatch({ type: INVESTOR_ID_FETCH_START });
    api.get("home" + env + "/investor").then((response) => {
      if (response.ok) {
        dispatch({
          type: INVESTOR_ID_FETCH_SUCCESS,
          data: response.data,
        });
      } else {
        let arr = response.problem;
        dispatch({ type: INVESTOR_ID_FETCH_FAILURE, error: arr });
      }
    });
  };
};
//Action - Home page - starts
export const getInvestorId = () => {
  return (dispatch) => {
    dispatch({ type: INVESTOR_ID_FETCH_START });
    api.get("home" + env + "/investor").then((response) => {
      if (response.ok) {
        dispatch({ type: INVESTOR_ID_FETCH_SUCCESS, data: response.data });
      } else {
        if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: INVESTOR_ID_FETCH_FAILURE, error: arr });
        }
      }
    });
  };
};

//Action - Member type - personaMock/getPersonalInfoById/:investorId
export const getMemberType = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: MEMBER_TYPE_FETCH_START });
    api.get("home" + env + "/persona/" + investorAccountId).then((response) => {
      if (response.ok) {
        dispatch({ type: MEMBER_TYPE_FETCH_SUCCESS, data: response.data });
      } else {
        let arr = response.problem;
        dispatch({ type: MEMBER_TYPE_FETCH_FAILURE, error: arr });
      }
    });
  };
};
//personaMock API
export const getMemberTypeMock = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: MEMBER_TYPE_FETCH_START });
    api
      .get(
        "home" + env + "/personaMock/getPersonalInfoById/" + investorAccountId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MEMBER_TYPE_FETCH_SUCCESS, data: response.data });
        } else {
          let arr = response.problem;
          dispatch({ type: MEMBER_TYPE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - GET person-pot-info - person-pot-info/:investorId
export const getHomePageContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: HOME_FETCH_START });
    api
      .get("home" + env + "/person-pot-info/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: HOME_FETCH_SUCCESS, data: response.data.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: HOME_FETCH_FAILURE, error: arr });
        }
      });
  };
};

// Action - Total pot info - GET - person-totalPot-info/:investorId
export const getTotalPotInfo = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: TOTAL_POTINFO_FETCH_START });
    api
      .get("home" + env + "/person-totalPot-info/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TOTAL_POTINFO_FETCH_SUCCESS,
            potData: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: TOTAL_POTINFO_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Home page - ends

//Action - Account page - starts
//Action - My account details - personal-info/:investorId
export const getAccountPageContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: ACCOUNT_FETCH_START });
    api
      .get("myaccount" + env + "/personal-info/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: ACCOUNT_FETCH_SUCCESS, data: response.data.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: ACCOUNT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - My account details -  patch call
export const patchAccountPageContent = (investorAccountId, patchData) => {
  const payload = JSON.stringify(patchData);

  const headers = { Client: "current" };
  return (dispatch) => {
    dispatch({ type: ACCOUNT_PATCH_START });
    api
      .post(
        "myaccount" + env + "/personal-info/journey/" + investorAccountId,
        payload,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: ACCOUNT_PATCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: ACCOUNT_PATCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - My account details -  upload document
// const formData = new FormData();
// formData.append("document", file);
export const uploadDocument = (investorAccountId, journeyId, formData) => {
  const headers = { "content-type": "multipart/form-data" };
  return (dispatch) => {
    dispatch({ type: UPLOAD_DOC_PATCH_START });
    return new Promise((resolve, reject) => {
      api
        .post(
          "myaccount" +
            env +
            "/personal-info/uploadDocument/" +
            investorAccountId +
            "/" +
            journeyId,
          formData,
          headers,
        )
        .then((response) => {
          if (response.ok) {
            dispatch({ type: UPLOAD_DOC_PATCH_SUCCESS, data: response.data });
            resolve(response.data);
          } else if (response.status === 401) {
            dispatch({ type: FETCH_REFRESH_TOKEN_START });
            apiCallWithNewToken(dispatch);
            reject(new Error("Unauthorized"));
          } else {
            let arr = response.problem;
            dispatch({ type: UPLOAD_DOC_PATCH_FAILURE, error: arr });
            reject(new Error(arr));
          }
        })
        .catch((error) => {
          dispatch({ type: UPLOAD_DOC_PATCH_FAILURE, error: error.message });
          reject(error);
        });
    });
  };
};

export const submitDocument = (investorAccountId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    const headers = { "content-type": "application/json" };
    dispatch({ type: SUBMIT_DOC_PATCH_START });
    api
      .post(
        "myaccount" +
          env +
          "/personal-info/submitDocument/" +
          investorAccountId,
        payload,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: SUBMIT_DOC_PATCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: SUBMIT_DOC_PATCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Account page - ends

//Action - Manage page - starts
//Action - Manage-Contribution - contributions/manage/:investorId
export const getMangeContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: MANAGE_FETCH_START });
    api
      .get("node" + env + "/contribution/schedules/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MANAGE_FETCH_SUCCESS, data: response.data.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: MANAGE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
export const postContributionRates = (
  investorId,
  investorAccountId,
  payloadData,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: POST_CONTRIBUTION_RATES_FETCH_START });
    api
      .post(
        "node" +
          env +
          "/contribution/rates/" +
          investorId +
          "/" +
          investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: POST_CONTRIBUTION_RATES_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: POST_CONTRIBUTION_RATES_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Manage page - ends

//Fund history - - starts
//Action - Fund history - investordev/fundHistory/21696677?startDate=2020-1-1&endDate=2020-4-1
export const getFundHistoryContent = (
  investorAccountId,
  startDate,
  endDate,
  onload,
) => {
  return (dispatch) => {
    onload ? dispatch({ type: FUND_HISTORY_FETCH_START }) : "";
    api
      .post(
        "fund" +
          env +
          "/fundHistory/" +
          investorAccountId +
          "?startDate=" +
          startDate +
          "&endDate=" +
          endDate,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: FUND_HISTORY_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FUND_HISTORY_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Fund history - ends

//Address lookup- - starts
//Action - address-lookup - myaccountdev/adress-lookup/SW85TH
export const getAddress = (postCode, investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: ADDRESS_FETCH_START });
    api
      .get(
        "node" + env + "/address/lookup/" + postCode + "/" + investorAccountId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: ADDRESS_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: ADDRESS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Address lookup - ends

//Funds savings - - starts
//Action -funds savings - pot-info/savings/
export const getFundSavingsContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: FUNDS_SAVINGS_FETCH_START });
    api
      .get("node" + env + "/pot-info/savings/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: FUNDS_SAVINGS_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FUNDS_SAVINGS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Member list- - starts
//Action - member-list - /pot-info/member-list
export const getMemberList = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: MEMBER_LIST_FETCH_START });
    api
      .get("node" + env + "/pot-info/member-list/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MEMBER_LIST_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: MEMBER_LIST_FETCH_FAILURE, error: arr });
        }
      });
  };
};

export const getMemberDetails = (investorAccountId, potId) => {
  return (dispatch) => {
    dispatch({ type: MEMBER_DETAILS_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/pot-info/membership-details/" +
          investorAccountId +
          "/" +
          potId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MEMBER_DETAILS_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: MEMBER_DETAILS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - member-list - ends

//Action - Retirement application - starts
//Action - Retirement application - retirementdev/application/id
export const getRetireApplicationContent = (
  investorAccountId,
  editingPage,
  retirementId,
) => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_APPLICATION_FETCH_START });
    api
      .get(
        "retirement" +
          env +
          "/application/" +
          investorAccountId +
          "/" +
          retirementId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: RETIREMENT_APPLICATION_FETCH_SUCCESS,
            data: response.data,
            editingPage: editingPage,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: RETIREMENT_APPLICATION_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - get zendesk chat token
export const getChatToken = (investorId) => {
  return (dispatch) => {
    dispatch({ type: CHAT_TOKEN_START });
    api.get("node" + env + "/chat/token/" + investorId).then((response) => {
      if (response.ok) {
        dispatch({ type: CHAT_TOKEN_SUCCESS, data: response.data });
      } else {
        let arr = response.problem;
        dispatch({ type: CHAT_TOKEN_FAILURE, error: arr });
      }
    });
  };
};
export const patchRetireApplicationStep = (
  investorAccountId,
  payloadData,
  editingPage,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: RETIREMENT_APPLICATION_PATCH_START });
    api
      .post("retirement" + env + "/application/" + investorAccountId, payload)
      .then((response) => {
        if (response.data?.message?.toLowerCase() != "success") {
          dispatch({
            type: RETIREMENT_APPLICATION_PATCH_FAILURE,
            error: response.data?.message,
          });
          return;
        }
        if (response.ok) {
          dispatch({
            type: RETIREMENT_APPLICATION_PATCH_SUCCESS,
            data: response.data,
            editingPage: editingPage,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: RETIREMENT_APPLICATION_PATCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - Retirement application - retirementdev/getRetirementapplication/id
export const getSchemeProtectionContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: SCHEME_PROTECTION_FETCH_START });
    api
      .get(
        "retirement" +
          env +
          "/investors/" +
          investorAccountId +
          "/scheme-specific-protection",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: SCHEME_PROTECTION_FETCH_SUCCESS,
            data: response.data.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: SCHEME_PROTECTION_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Retirement application - ends

//Action - Beneficiary application - starts
export const getBeneficiaryDetails = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: BENEFICIARY_FETCH_START });
    api
      .get("node" + env + "/beneficiary/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: BENEFICIARY_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: BENEFICIARY_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Beneficiary application - ends

//Action - Beneficiary post call - starts
export const submitBeneficiaryPayload = (investorAccountId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    const headers = { "content-type": "application/json" };
    dispatch({ type: BENEFICIARY_POST_FETCH_START });
    api
      .post(
        "node" + env + "/beneficiary/addRelationship/" + investorAccountId,
        payload,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: BENEFICIARY_POST_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: BENEFICIARY_POST_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Beneficiary post call - ends

//Action - Beneficiary Patch call - starts
export const addBeneficiaryPayload = (
  investorAccountId,
  potId,
  payloadData,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    const headers = { "content-type": "application/json" };
    dispatch({ type: BENEFICIARY_PATCH_FETCH_START });
    var apiurl = "";
    if (potId) {
      apiurl = `node${env}/beneficiary/addBeneficiary/${investorAccountId}/${potId}`;
    } else {
      apiurl = `node${env}/beneficiary/addBeneficiary/${investorAccountId}`;
    }

    api.patch(apiurl, payload, headers).then((response) => {
      if (response.ok) {
        dispatch({
          type: BENEFICIARY_PATCH_FETCH_SUCCESS,
          data: response.data,
        });
      } else if (response.status === 401) {
        dispatch({ type: FETCH_REFRESH_TOKEN_START });
        apiCallWithNewToken(dispatch);
      } else {
        let arr = response.problem;
        dispatch({ type: BENEFICIARY_PATCH_FETCH_FAILURE, error: arr });
      }
    });
  };
};
//Action - Beneficiary Patch call - ends
//Action - Transactions summary - - starts
//Action -transactions summary - transactions/summary/
export const getTransactionsSummaryContent = (
  investorId,
  investorAccountId,
  startDate,
  endDate,
) => {
  return (dispatch) => {
    dispatch({ type: TRANSACTIONS_SUMMARY_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/transactions/summary/" +
          investorId +
          "?investorAccountId=" +
          investorAccountId +
          "&effectiveDateFrom=" +
          startDate +
          "&effectiveDateTo=" +
          endDate,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TRANSACTIONS_SUMMARY_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: TRANSACTIONS_SUMMARY_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - Transactions summary - ends

//Action - TransferIn - - starts
export const getTransferInData = (investorId) => {
  const redirectUrl = window.location.href.split("#")[0];
  return (dispatch) => {
    dispatch({ type: TRANSERIN_FETCH_START });
    return api
      .get(
        "node" +
          env +
          "/transfers-in/token/" +
          investorId +
          "?redirect_url=" +
          redirectUrl,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TRANSERIN_FETCH_SUCCESS,
            data: response.data,
          });
          return response.data;
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: TRANSERIN_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - TransferIn - ends

// fetch new auth token and make api call to retrieve data
export const apiCallWithNewToken = async (dispatch, apiType = "") => {
  window.localStorage.removeItem("token");
  window.sessionStorage.removeItem("token");
  const refreshToken =
    sessionStorage.getItem("refresh_token") ||
    localStorage.getItem("refresh_token");
  if (refreshToken !== undefined) {
    const newToken = await fetchRefreshToken();
    if (newToken?.access_token) {
      window.sessionStorage.setItem("token", newToken?.access_token);

      if (apiType === "investor") {
        fetchInvestorDetailsWithNewToken();
        setTimeout(() => {
          dispatch({
            type: FETCH_REFRESH_TOKEN_SUCCESS,
          });
          //TODO - Need to check this as its redirecting to home page
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.reload();
        }, 5000);
      } else {
        setTimeout(() => {
          dispatch({
            type: FETCH_REFRESH_TOKEN_SUCCESS,
          });
          window.location.reload();
        }, 5000);
      }
    } else {
      dispatch({
        type: FETCH_REFRESH_TOKEN_FAILURE,
        error:
          "Unable to fetch refresh token. Please start new session or refresh page manually",
      });
    }
  } else {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.reload();
  }
};

//Action - retirement guidance explorer - starts
export const getGuidanceExplorerContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: GUIDANCE_EXPLORER_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.guidance +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: GUIDANCE_EXPLORER_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: GUIDANCE_EXPLORER_FAILURE, error: arr });
        }
      });
  };
};
//Action - retirement guidance explorer - ends

//Action - retirement guidance explorer card - starts
export const getGuidanceExplorerCardContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: GUIDANCE_EXPLORER_CARD_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/descendants/" +
          SETTINGS.guidance +
          "/" +
          investorId +
          "?skip=0&take=50",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: GUIDANCE_EXPLORER_CARD_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: GUIDANCE_EXPLORER_CARD_FAILURE, error: arr });
        }
      });
  };
};
//Action - retirement guidance explorer card - ends
//FundList Action
//Action - CMS fund list fetch action starts
export const getCMSFundList = (investorId) => {
  return (dispatch) => {
    dispatch({ type: CMS_FUND_LIST_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.investmentData +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: CMS_FUND_LIST_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: CMS_FUND_LIST_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - CMS fund list fetch action ends
//Action - All Documents - - starts
//Action - All Documents - document/:investorId/
export const getAllDocumentsContent = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: ALL_DOCUMENTS_FETCH_START });
    api
      .get("node" + env + "/documents/getAllDocs/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: ALL_DOCUMENTS_FETCH_SUCCESS,
            data: response?.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr =
            response.status === 404
              ? response?.data?.message
              : response.problem;
          dispatch({ type: ALL_DOCUMENTS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - All Documents - - ends
//Action - Get Document - - starts
//Action - Get Document - GetDocument/:docIndex
export const getDocumentContent = (investorAccountId, docIndex) => {
  return (dispatch) => {
    dispatch({ type: GET_DOCUMENT_FETCH_START });

    return api
      .get(
        "node" +
          env +
          "/documents/getDocument/" +
          investorAccountId +
          "/" +
          docIndex,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: GET_DOCUMENT_FETCH_SUCCESS,
            data: response.data,
          });
          return response.data; // ✅ Return data for awaiting
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr =
            response.status === 404 ? response.problem : response.problem;
          dispatch({ type: GET_DOCUMENT_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - Get Document - - ends

//Retirement Steps start

export const setRetirementDetails = (currentStep, details) => {
  return (dispatch) => {
    dispatch({
      type: SET_RETIREMENT_APPLICATION_DETAILS,
      data: { currentStep, details },
    });
  };
};
export const handleBeginButtonClick = (currentStep) => {
  return (dispatch) => {
    dispatch({
      type: BEGIN_RETIREMENT_APPLICATION_CLICK_START,
      data: currentStep,
    });
  };
};
export const handleBackButtonClick = (
  isHomeScreen,
  mainStepNo,
  disableSection,
  backButtonClicked,
) => {
  return (dispatch) => {
    dispatch({
      type: BACK_BUTTON_RETIREMENT_APPLICATION_STEPS,
      data: { isHomeScreen, mainStepNo, disableSection, backButtonClicked },
    });
  };
};

export const retirementChoiceSubStepHandler = (data) => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS, data });
  };
};
export const directRetirementStepChange = (step) => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_DIRECT_STEP_CHANGE, data: step });
  };
};

export const retirementConfirmChoiceStepHandler = (data) => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_CONFIRM_CHOICE_SUB_STEPS, data });
  };
};

export const handleNextButtonClick = (currentStep, dataObject) => {
  return (dispatch) => {
    if (currentStep == RA_STEPS_IDENTIFIERS.BANK_MANDATE) {
      dispatch({
        type: NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS,
        data: { currentStep, dataObject },
      });
    } else {
      dispatch({
        type: NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS,
        data: currentStep,
      });
    }
  };
};

export const startPotSelectionAgainHandler = () => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION });
  };
};

////Retirement Steps End

//Action - CMS retirement living standards fetch action starts
export const getLivingStandards = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LIVING_STANDARD_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.retirementLivingStandard +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LIVING_STANDARD_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LIVING_STANDARD_FETCH_FAILURE, error: arr });
        }
      });
  };
};
export const getLivingStandardsAssumptions = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LIVING_STANDARD_ASSUMPTIONS_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.retirementGuidanceComparison +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LIVING_STANDARD_ASSUMPTIONS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: LIVING_STANDARD_ASSUMPTIONS_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - CMS retirement living standards ends

//Action - Product overview page - starts
export const productOverviewContent = (url, investorId) => {
  const urlEn = "/" + url + "/poverview";
  const localParam = encodeURIComponent(urlEn);
  return (dispatch) => {
    dispatch({ type: PRODUCT_OVERVIEW_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.guidance +
          localParam +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: PRODUCT_OVERVIEW_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: PRODUCT_OVERVIEW_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Product overview page - ends

//Action - Add document status for read post call - starts
export const insertDocumentReadStatus = (investorAccountId, docIndexId) => {
  return (dispatch) => {
    const headers = { "content-type": "application/json" };
    dispatch({ type: DOCUMENT_READ_STATUS_POST_FETCH_START });
    api
      .post(
        "node" +
          env +
          "/documents/insertDocReadStatus/" +
          investorAccountId +
          "/" +
          docIndexId,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({
            type: DOCUMENT_READ_STATUS_POST_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - Add document status post call - ends

//Action - communication preference post call- starts
export const commPreference = (investorAccountId, payload) => {
  return (dispatch) => {
    dispatch({ type: COMM_PREFERENCE_FETCH_START });
    api
      .post(
        "home" + env + "/communicationPreference/" + investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: COMM_PREFERENCE_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: COMM_PREFERENCE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - communication preference post call - ends

//Action - your goals get and post call- starts
export const getYourGoals = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: YOUR_GOALS_FETCH_START });
    api.get("home" + env + "/goals/" + investorAccountId).then((response) => {
      if (response.ok) {
        dispatch({
          type: YOUR_GOALS_FETCH_SUCCESS,
          data: response.data,
        });
      } else if (response.status === 401) {
        dispatch({ type: FETCH_REFRESH_TOKEN_START });
        apiCallWithNewToken(dispatch);
      } else {
        let arr = response.problem;
        dispatch({ type: YOUR_GOALS_FETCH_FAILURE, error: arr });
      }
    });
  };
};

export const postYourGoals = (investorAccountId, goalId, taskId) => {
  return (dispatch) => {
    dispatch({ type: POST_YOUR_GOALS_FETCH_START });
    api
      .post(
        "home" +
          env +
          "/goalTasksStatus/" +
          investorAccountId +
          "?goalId=" +
          goalId +
          "&taskId=" +
          taskId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: POST_YOUR_GOALS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: POST_YOUR_GOALS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - your goals get and post call - ends

//Action - Learn Landing Content - starts
export const learnLandingContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_LANDING_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.learn +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: LEARN_LANDING_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LEARN_LANDING_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Learn Landing Content - ends
//Action - Learn Landing Content - starts
export const learnLandingFilterContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_LANDING_FILTER_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/descendants/" +
          SETTINGS.learn +
          "/" +
          investorId +
          "?skip=0&take=1000&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LEARN_LANDING_FILTER_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LEARN_LANDING_FILTER_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Learn Landing Content - ends
//Action - Learn Landing FAQ - starts
export const learnFaqContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_LANDING_FAQ_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/descendants/" +
          SETTINGS.fAQ +
          "/" +
          investorId +
          "?sort=sortOrder:asc&skip=0&take=1000&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LEARN_LANDING_FAQ_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LEARN_LANDING_FAQ_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Learn Landing Content - ends

//Action - CMS for future calculator landing fetch action starts
export const FutureCalculatorHomeContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: FC_HOME_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.planYourFuture +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: FC_HOME_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: FC_HOME_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action -CMS for future calculator ends

// Action - GetIn Touch -  upload document
export const uploadGetInTouchDocument = (investorAccountId, formData) => {
  // TODO: check and change api interceptor
  const headers = { "content-type": "multipart/form-data" };
  return (dispatch) => {
    dispatch({ type: UPLOAD_DOC_GETINTOUCH_START });
    // TODO: Add correct url when api is implemented
    api
      .post("node" + env + "/upload/" + investorAccountId, formData, headers)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: UPLOAD_DOC_GETINTOUCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: UPLOAD_DOC_GETINTOUCH_FAILURE, error: arr });
        }
      });
  };
};

// Action - GetIn Touch Un-authorised-  upload document
export const uploadGetInTouchDocumentUnAuth = (formData) => {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  const randomNumber = (array[0] % 900000) + 100000;
  const headers = { "content-type": "multipart/form-data" };
  return (dispatch) => {
    dispatch({ type: UPLOAD_DOC_GETINTOUCH_START });
    api
      .post(
        "node" + env + "/upload/" + randomNumber + "/getintouch/unauthcall",
        formData,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: UPLOAD_DOC_GETINTOUCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: UPLOAD_DOC_GETINTOUCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - GetIn Touch -  upload document - ends

//Action - Footer content - starts
export const getFooterContentCms = (footerItemUrl, investorId) => {
  return (dispatch) => {
    dispatch({ type: FOOTER_CONTENT_FETCH_START });
    api
      .get(
        "node" + env + "/cms/content/item/" + footerItemUrl + "/" + investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FOOTER_CONTENT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FOOTER_CONTENT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Footer content - ends

//Action - Learn Landing Jargon Buster - starts
export const learnJargonBusterContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_LANDING_JARGON_BUSTER_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/descendants/" +
          SETTINGS.jargonBuster +
          "/" +
          investorId +
          "?skip=0&take=1000&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LEARN_LANDING_JARGON_BUSTER_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: LEARN_LANDING_JARGON_BUSTER_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - Learn Landing Jargon Buster - ends

//Action - I want to dropdown - starts
export const iWantToComboContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: I_WANT_TO_COMBO_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.iWantToMenu +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: I_WANT_TO_COMBO_FETCH_SUCCESS,
            data: response?.data?.properties?.menu?.items,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: I_WANT_TO_COMBO_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - I want to dropdown - ends

//InvestmentsData Action
//Action - Investment data fetch action starts
export const getInvestmentsData = (investorId) => {
  return (dispatch) => {
    dispatch({ type: INVESTMENT_DATA_FETCH_START });
    api
      .get("node" + env + "/investment/" + investorId + "/savings")
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: INVESTMENT_DATA_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: INVESTMENT_DATA_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Investment data fetch action Ends

//Action - Calculate pot value - start
export const calculatePotValue = (
  payloadData,
  investorId,
  fromTTPopUp = false,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: CALCULATE_POT_FETCH_START });
    api
      .post("retirement" + env + "/timeTravel/calculate/" + investorId, payload)
      .then((response) => {
        if (response.ok) {
          if (fromTTPopUp) {
            dispatch({
              type: CALCULATE_POT_FETCH_MODAL_SUCCESS,
              data: response.data,
            });
          } else {
            dispatch({
              type: CALCULATE_POT_FETCH_SUCCESS,
              data: response.data,
            });
          }
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: CALCULATE_POT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Calculate pot value - Ends

// Action - retirement ID&V -  patch call
export const RetirementQr = (investorAccountId, patchData) => {
  const payload = JSON.stringify(patchData);

  const headers = { Client: "current" };
  return (dispatch) => {
    dispatch({ type: RETIREMENT_QR_START });
    api
      .post(
        "myaccount" + env + "/personal-info/journey/" + investorAccountId,
        payload,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: RETIREMENT_QR_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: RETIREMENT_QR_FAILURE, error: arr });
        }
      });
  };
};

//Action - retirementIdentity- personal-info/:investorId
export const retirementIdentity = (investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: RETIREMENT_IDENTITY_FETCH_START });
    api
      .get("myaccount" + env + "/personal-info/" + investorAccountId)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: RETIREMENT_IDENTITY_FETCH_SUCCESS,
            data: response.data.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: RETIREMENT_IDENTITY_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Actions related to home Promo - starts
export const homePromoContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: HOME_PROMO_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.home +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: HOME_PROMO_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: HOME_PROMO_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Actions related to home Promo - ends

//Action - get notifications - starts
export const getNotifications = (investorId) => {
  return (dispatch) => {
    dispatch({ type: NOTIFICATION_FETCH_START });
    api
      .get("node" + env + "/documents/messageDocCount/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: NOTIFICATION_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: NOTIFICATION_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get notifications - ends

//Action - CMS time travel assumptions ends
export const getTimeTravelAssumptions = (investorId) => {
  return (dispatch) => {
    dispatch({ type: TIME_TRAVEL_ASSUMPTIONS_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.timeTravelAssumptions +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - CMS time travel assumptions ends

//Action - get contribution rates starts
export const getContributionRates = (investorAccountId, employerId) => {
  return (dispatch) => {
    dispatch({ type: CONTRIBUTION_RATES_FETCH_START });
    api
      .get(
        "account" +
          env +
          "/investor-accounts/" +
          investorAccountId +
          "/contribution-rates?employerId=" +
          employerId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CONTRIBUTION_RATES_FETCH_SUCCESS,
            data: response.data.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: CONTRIBUTION_RATES_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - get contribution rates ends
//Actions- home alert starts
export const homeAlertContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: HOME_ALERT_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.broadcastNotification +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: HOME_ALERT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: HOME_ALERT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Actions - home alert ends

//Action - get calculator CMS configuration starts
export const getCalculatorCMSConfig = () => {
  return (dispatch) => {
    dispatch({ type: CALCULATOR_CMS_CONFIG_FETCH_START });
    api
      .get("retirement" + env + "/contribution/calculator/configuration")
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CALCULATOR_CMS_CONFIG_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: CALCULATOR_CMS_CONFIG_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - get contribution rates ends

// Action - Post contribution calculator content starts
export const postContributionCalcContent = (investorId, postData) => {
  const payload = JSON.stringify(postData);
  return (dispatch) => {
    dispatch({ type: CONTRIBUTION_CALCULATOR_POST_FETCH_START });
    api
      .post(
        "retirement" + env + "/contribution/calculate/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({
            type: CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
// Action - Post contribution calculator content ends

//Action - TRA post - starts
export const postTargetRetirementAge = (investorId, investorAccountId, age) => {
  return (dispatch) => {
    dispatch({ type: TRA_POST_FETCH_START });
    // Creating url if investorAccountId is null then total pot level else individual pot level
    const url =
      investorAccountId != 0
        ? "home" +
          env +
          "/investor/calculateTRA/" +
          investorId +
          "/" +
          investorAccountId +
          "/" +
          age
        : "home" + env + "/investor/calculateTRA/" + investorId + "/" + age;
    return api.post(url).then((response) => {
      if (response.ok) {
        dispatch({
          type: TRA_POST_FETCH_SUCCESS,
          data: response.data,
        });
        return response.data; // return response to the caller
      } else if (response.status === 401) {
        dispatch({ type: FETCH_REFRESH_TOKEN_START });
        apiCallWithNewToken(dispatch);
      } else {
        let arr = response.problem;
        dispatch({ type: TRA_POST_FETCH_FAILURE, error: arr });
      }
    });
  };
};

//Action - TRA post - ends
//Action - GET connected pension
export const getConnectedPension = (investorId) => {
  return (dispatch) => {
    dispatch({ type: CONNECTED_PENSION_FETCH_START });
    api
      .get(
        "account" +
          env +
          "/investor-accounts/" +
          investorId +
          "/linkedPensions",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CONNECTED_PENSION_FETCH_SUCCESS,
            data: response.data.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: CONNECTED_PENSION_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - GET future calculator flexi result
export const getFutureCalculatorFlexiResult = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_FLEXI_RESULT_FETCH_START });

    api
      .post(
        "retirement" + env + "/planYourFuture/calculator/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_FLEXI_RESULT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_FLEXI_RESULT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get future calculator flexi result - ends

//Action - GET future calculator monthly income result
export const getFutureCalculatorMonthlyResult = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_INCOME_RESULT_FETCH_START });

    api
      .post(
        "retirement" + env + "/planYourFuture/managedIncome/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_INCOME_RESULT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_INCOME_RESULT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get future calculator monthly income - ends

//Action - GET future calculator future annuity
export const getFutureCalculatorAnnuityResult = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_ANNUITY_RESULT_FETCH_START });

    api
      .post(
        "retirement" + env + "/planYourFuture/futureAnnuity/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_ANNUITY_RESULT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_ANNUITY_RESULT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get future calculator future annuity - ends

//Action - GET total worth amount
export const getTotalWorth = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_WORTH_AMOUNT_FETCH_START });

    api
      .post(
        "retirement" + env + "/contribution/calculate/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_WORTH_AMOUNT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_WORTH_AMOUNT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - GET total worth amount - ends

//Action- about TPT starts
export const AboutTPTContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: ABOUT_TPT_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/children/" +
          SETTINGS.aboutTpt +
          "/" +
          investorId +
          "?sort=sortOrder:asc&skip=0&take=10&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: ABOUT_TPT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: ABOUT_TPT_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action- about TPT ends

//Action - GET future calculator flexi line chart
export const getFutureCalculatorFlexiLineChart = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_FLEXI_LINECHART_FETCH_START });
    api
      .post(
        "retirement" + env + "/planYourFuture/potValueLineGraph/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_FLEXI_LINECHART_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_FLEXI_LINECHART_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//GET future calculator flexi line chart - ends

//Action - GET future calculator flexi monthly income chart
export const getFutureCalculatorFlexiMonthChart = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_FLEXI_INCOMECHART_FETCH_START });

    api
      .post(
        "retirement" + env + "/planYourFuture/incomeGraph/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_FLEXI_INCOMECHART_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_FLEXI_INCOMECHART_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//GET future calculator flexi monthly income chart - ends

//Action - GET future calculator managed income chart
export const getFutureCalculatorManagedIncomeChart = (
  investorId,
  payloadData,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_MANAGED_INCOMECHART_FETCH_START });
    api
      .post(
        "retirement" + env + "/planYourFuture/managedIncomeChart/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_MANAGED_INCOMECHART_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_MANAGED_INCOMECHART_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//GET future calculator managed income chart - ends

//Action - GET future calculator annuity chart
export const getFutureCalculatorAnnuityChart = (investorId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FC_ANNUITYCHART_FETCH_START });
    api
      .post(
        "retirement" + env + "/planYourFuture/futureAnnuityChart/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_ANNUITYCHART_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FC_ANNUITYCHART_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//GET future calculator annuity chart - ends

//GET future calculator assumption
export const getPlanyourFutureAssumptions = (investorId) => {
  return (dispatch) => {
    dispatch({ type: FC_ASSUMPTIONS_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.planYourFutureAssumptions +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FC_ASSUMPTIONS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({
            type: FC_ASSUMPTIONS_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - CMS future calculator assumption ends
// Action - help guides starts
export const learnHelpGuidesContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_HELP_GUIDES_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/descendants/" +
          SETTINGS.helpGuides +
          "/" +
          investorId +
          "?skip=0&take=1000&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LEARN_HELP_GUIDES_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LEARN_HELP_GUIDES_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - help guides ends
//Action - Scheme documents - starts
export const getSchemeDocuments = (investorId) => {
  return (dispatch) => {
    dispatch({ type: SCHEMA_DOCUMENT_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.schemeDocuments +
          "/" +
          investorId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: SCHEMA_DOCUMENT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: SCHEMA_DOCUMENT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Scheme documents - ends

//Action - Savings Fund Switch - start
export const savingsFundSwitch = (
  payloadData,
  investorId,
  investorAccountId,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FUND_SWITCH_FETCH_START });
    api
      .post(
        "node" + env + "/investment/" + investorId + "/" + investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: FUND_SWITCH_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response;
          dispatch({ type: FUND_SWITCH_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Savings Fund Switch - Ends

//drawdown Action
//Action - Drawdown data fetch action starts
export const getDrawdownData = (investorId) => {
  return (dispatch) => {
    dispatch({ type: DRAWDOWN_DATA_FETCH_START });
    api
      .get("node" + env + "/investment/" + investorId + "/drawdown")
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: DRAWDOWN_DATA_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: DRAWDOWN_DATA_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Drawdown data fetch action Ends

//Action - learn support starts
export const learnSupportContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LEARN_SUPPORT_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/children/" +
          SETTINGS.support +
          "/" +
          investorId +
          "?sort=sortOrder:asc&skip=0&take=10&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LEARN_SUPPORT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LEARN_SUPPORT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - learn support ends

//Action - TRANSFER_OUT - start
export const transferOut = (payloadData, investorId) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: TRANSFER_OUT_FETCH_START });
    api
      .post("node" + env + "/transfer-out/" + investorId, payload)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: TRANSFER_OUT_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: TRANSFER_OUT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - TRANSFER_OUT - Ends

//Action - learn useful links starts
export const usefulLinksContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LINKS_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.usefulLinks +
          "/" +
          investorId,
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: LINKS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LINKS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - learn useful links ends
//Action - messages starts

export const getMessagesContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: MESSAGES_FETCH_START });
    api
      .get("node" + env + "/notifications/messages/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MESSAGES_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: MESSAGES_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - messages ends
//Action - messages-read starts

export const messagesReadContent = (communicationId, payloadData) => {
  const payload = JSON.stringify(payloadData);
  const headers = {
    "x-isagent-mode": "true",
    "content-type": "application/json",
  };
  return (dispatch) => {
    dispatch({ type: MESSAGES_READ_FETCH_START });
    api
      .put(
        "node" + env + "/notifications/messages/" + communicationId,
        payload,
        headers,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: MESSAGES_READ_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: MESSAGES_READ_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - messages-read ends

//Action - CMS fund list fetch action starts
export const getFundList = (investorId, investorAccountId) => {
  return (dispatch) => {
    dispatch({ type: CMS_FUND_LIST_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/investment/funds/" +
          investorId +
          "/" +
          investorAccountId,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: CMS_FUND_LIST_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: CMS_FUND_LIST_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - CMS fund list fetch action ends
// Action - life assurance starts
export const lifeAssuranceContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: LIFE_ASSURANCE_FETCH_START });
    api
      .get("node" + env + "/contribution/lifeassurance/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: LIFE_ASSURANCE_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: LIFE_ASSURANCE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - life assurance ends

export const gradesContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: GRADES_FETCH_START });
    api
      .get("node" + env + "/contribution/grades/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: GRADES_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: GRADES_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - Contribution view - - starts
export const getContributionContent = (
  investorId,
  investorAccountId,
  startDate,
  endDate,
) => {
  return (dispatch) => {
    dispatch({ type: CONTRIBUTION_VIEW_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/transactions/pension-contributions/" +
          investorId +
          "?investorAccountId=" +
          investorAccountId +
          "&effectiveDateFrom=" +
          startDate +
          "&effectiveDateTo=" +
          endDate,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CONTRIBUTION_VIEW_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: CONTRIBUTION_VIEW_FETCH_FAILURE, error: arr });
        }
      });
  };
};

//Action - Contribution view - ends

//Action - Get Title starts
export const getTitle = (investorId) => {
  return (dispatch) => {
    dispatch({ type: GET_TITLE_FETCH_START });
    api
      .get("myaccount" + env + "/personal-info/titles/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: GET_TITLE_FETCH_SUCCESS, data: response.data.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: GET_TITLE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Get Title ends

//Action - Feedback - starts
export const sendFeedbackDetails = (investorAccountId, feedbackPayload) => {
  const payload = JSON.stringify(feedbackPayload);
  return (dispatch) => {
    dispatch({ type: FEEDBACK_FETCH_START });
    api
      .post("node" + env + "/feedback/" + investorAccountId, payload)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: FEEDBACK_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FEEDBACK_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Feedback - ends

//Action - Savings Fund Switch - Future - start
export const savingsFundSwitchFuture = (
  payloadData,
  investorId,
  investorAccountId,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FUND_SWITCH_FUTURE_FETCH_START });
    api
      .patch(
        "node" + env + "/investment/" + investorId + "/" + investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FUND_SWITCH_FUTURE_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response;
          dispatch({ type: FUND_SWITCH_FUTURE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Savings Fund Switch - Future - Ends
//Actions related to Help Guides Illustration - starts
export const helpGuidesIllustration = (investorId) => {
  return (dispatch) => {
    dispatch({ type: HELP_GUIDES_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.helpGuides +
          "/" +
          investorId +
          "?expand=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: HELP_GUIDES_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: HELP_GUIDES_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Actions related to Help Guides Illustration - ends
//Actions related to FAQ Illustration - starts
export const FaqIllustration = (investorId) => {
  return (dispatch) => {
    dispatch({ type: FAQ_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.fAQ +
          "/" +
          investorId +
          "?expand=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FAQ_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: FAQ_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Actions related to FAQ Illustration - ends
//Actions related to JARGON Illustration - starts
export const jargonIllustrations = (investorId) => {
  return (dispatch) => {
    dispatch({ type: JARGON_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.jargonBuster +
          "/" +
          investorId +
          "?expand=properties[$all]",
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: JARGON_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: JARGON_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Actions related to JARGON Illustration - ends

//Actions -  related to country list -starts
export const getCountry = () => {
  return (dispatch) => {
    dispatch({ type: COUNTRY_FETCH_START });
    api.get("myaccount" + env + "/countries").then((response) => {
      if (response.ok) {
        dispatch({ type: COUNTRY_FETCH_SUCCESS, data: response.data });
      } else if (response.status === 401) {
        dispatch({ type: FETCH_REFRESH_TOKEN_START });
        apiCallWithNewToken(dispatch);
      } else {
        let arr = response.problem;
        dispatch({ type: COUNTRY_FETCH_FAILURE, error: arr });
      }
    });
  };
};

//Actions -  related to country list - ends

//Action - change investment learn content - starts
export const changeInvestmentContent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_INVESTMENT_FETCH_START });
    api
      .get(
        "node" +
          env +
          "/cms/content/item/" +
          SETTINGS.changeInvestment +
          "/" +
          investorId +
          "?expand=properties[$all]&fields=properties[$all]",
      )

      .then((response) => {
        if (response.ok) {
          dispatch({
            type: CHANGE_INVESTMENT_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch, "investor");
        } else {
          let arr = response.problem;
          dispatch({ type: CHANGE_INVESTMENT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - change investment learn content - end

//Action - Lump sums withdrawal - start
export const lumpSumsWithdrawal = (
  payloadData,
  investorId,
  investorAccountId,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: LUMP_SUMS_FETCH_START });
    api
      .post(
        "node" + env + "/in-retirement/" + investorId + "/" + investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({ type: LUMP_SUMS_FETCH_SUCCESS, data: response.data });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response;
          dispatch({ type: LUMP_SUMS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - Lump sums withdrawal - Ends

// Action - Tax free Cash Income creation - Starts
export const taxFreeIncomeCreation = (
  investorId,
  investorAccountId,
  payloadData,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: TAX_FREE_CREATE_FETCH_START });
    api
      .post(
        "node" +
          env +
          "/investment/create-crystallisations/" +
          investorId +
          "/" +
          investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TAX_FREE_CREATE_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response;
          dispatch({ type: TAX_FREE_CREATE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action - Tax free Cash Income creation - Ends

// Action -Tax free Cash Income Stops - Start
export const taxFreeIncomeStop = (
  investorId,
  investorAccountId,
  payloadData,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: TAX_FREE_STOP_FETCH_START });
    api
      .post(
        "node" +
          env +
          "/investment/deactivate-crystallisations/" +
          investorId +
          "/" +
          investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: TAX_FREE_STOP_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response;
          dispatch({ type: TAX_FREE_STOP_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action -Tax free Cash Income Stops - Ends

// Action -Manage flexi access income - start
export const manageFlexiAccessIncome = (
  payloadData,
  investorId,
  investorAccountId,
) => {
  const payload = JSON.stringify(payloadData);
  return (dispatch) => {
    dispatch({ type: FLEXI_ACCESS_INCOME_FETCH_START });
    api
      .post(
        "node" +
          env +
          "/investment/manageFlexiAccess/" +
          investorId +
          "/" +
          investorAccountId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: FLEXI_ACCESS_INCOME_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: FLEXI_ACCESS_INCOME_FETCH_FAILURE, error: arr });
        }
      });
  };
};
// Action -Manage flexi access income - stop

//Action - View Illustration - Start
export const getIllustrationContent = (requestData) => {
  const payload = JSON.stringify(requestData);
  return (dispatch) => {
    dispatch({ type: ILLUSTRATION_FETCH_START });
    return api
      .post("retirement" + env + "/illustrations", payload, {
        responseType: "blob",
      })
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: ILLUSTRATION_FETCH_SUCCESS,
            data: response.data,
          });
          return response.data;
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: ILLUSTRATION_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - View Illustration - End

//Action - get payout and current rate - Start
export const getPayoutRate = (investorId, dob) => {
  return (dispatch) => {
    dispatch({ type: PAYOUT_RATE_FETCH_START });
    api
      .get(
        "node" + env + "/in-retirement/configuration/" + investorId + "/" + dob,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: PAYOUT_RATE_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: PAYOUT_RATE_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get payout and current rate - End

//Action - get RA CMS Funds - Start
export const getRACMSFunds = (investorId) => {
  return (dispatch) => {
    dispatch({ type: RA_CMS_FUNDS_FETCH_START });
    api
      .get("node" + env + "/in-retirement/funds/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: RA_CMS_FUNDS_FETCH_SUCCESS,
            data: response.data,
          });
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: RA_CMS_FUNDS_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get RA CMS funds - End

//Action - get pension lab consent - Start
export const getPensionLabConsent = (investorId) => {
  return (dispatch) => {
    dispatch({ type: PENSION_LAB_CONSENT_FETCH_START });
    return api
      .get("node" + env + "/transfers-in/pension-lab/consent/" + investorId)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: PENSION_LAB_CONSENT_FETCH_SUCCESS,
            data: response.data,
          });
          return response.data; // ✅ Return data for awaiting
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({ type: PENSION_LAB_CONSENT_FETCH_FAILURE, error: arr });
        }
      });
  };
};
//Action - get pension lab consent - End

//Action - update pension lab consent - Start
export const updatePensionLabConsent = (investorId, consentPayload) => {
  const payload = JSON.stringify(consentPayload);
  return (dispatch) => {
    dispatch({ type: PENSION_LAB_CONSENT_UPDATE_FETCH_START });
    return api
      .post(
        "node" + env + "/transfers-in/pension-lab/consent/" + investorId,
        payload,
      )
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS,
            data: response.data,
          });
          return response.data;
        } else if (response.status === 401) {
          dispatch({ type: FETCH_REFRESH_TOKEN_START });
          apiCallWithNewToken(dispatch);
        } else {
          let arr = response.problem;
          dispatch({
            type: PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE,
            error: arr,
          });
        }
      });
  };
};
//Action - update pension lab consent - End

// Action - TRA change when fund switch required - starts
export const postTRAChangeWhenFundSwitchRequired = (
  investorId,
  investorAccountId,
  age,
) => {
  return (dispatch) => {
    dispatch({ type: TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START });
    const url =
      investorAccountId != 0
        ? "home" +
          env +
          "/investor/switchTRA/" +
          investorId +
          "/" +
          investorAccountId +
          "/" +
          age
        : "home" + env + "/investor/switchTRA/" + investorId + "/" + age;
    return api.post(url).then((response) => {
      if (response.ok) {
        dispatch({
          type: TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS,
          data: response.data,
        });
        return response.data; // return response to the caller
      } else if (response.status === 401) {
        dispatch({ type: FETCH_REFRESH_TOKEN_START });
        apiCallWithNewToken(dispatch);
      } else {
        let arr = response.problem;
        dispatch({
          type: TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE,
          error: arr,
        });
      }
    });
  };
};
// Action - TRA change when fund switch required - ends
